import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalculatorPaystationDetailComponent } from './paystation-detail.component';

@NgModule({
  declarations: [
    CalculatorPaystationDetailComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CalculatorPaystationDetailComponent
  ]
})
export class CalculatorPaystationDetailModule { }
